import _ from "lodash";

/**
 * Turns a DataGrid column config into the serializable column list the CSV
 * export endpoint expects: an ordered array of { field, header, format }.
 *
 * This makes the frontend column config the single source of truth for the
 * export's column SET, ORDER, and HEADER LABELS. The backend only maps each
 * `field` to a document path and applies the named `format` — so adding,
 * removing, reordering or renaming a column here flows into the CSV with no
 * backend change (as long as the field is one the backend already knows).
 *
 * `format` is a named formatter the backend understands (see BackEnd
 * exportCsv.FORMATTERS): "text" (default), "naText" (blank → "N/A"),
 * "startCase", "date" (YYYY-MM-DD, keeps "pending"), "qrDate" (Quality Reports
 * dates, blank → "N/A"), "activeInactive". A column omitting `csvFormat` is
 * exported as plain text, matching a grid cell with no special formatter.
 *
 * The header mirrors how the grid derives it: explicit `headerName`, else
 * start-cased `field` (see createSearchColumns).
 *
 * @param {Array} columnConfig  the list's column config (e.g. allItemsColumnConfig)
 * @returns {Array<{ field: string, header: string, format: string }>}
 */
export function buildCsvColumns(columnConfig) {
  return columnConfig.map((col) => ({
    field: col.field,
    header: col.headerName ?? _.startCase(col.field),
    format: col.csvFormat ?? "text",
  }));
}
